import { render, staticRenderFns } from "./projectmanagerDetail.vue?vue&type=template&id=111dbc10&"
import script from "./projectmanagerDetail.vue?vue&type=script&lang=js&"
export * from "./projectmanagerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports